export default "__VITE_ASSET__$esHsrKe__"